import io from 'socket.io-client';
import { merge } from 'lodash';
import store from '@/store';
import { bus } from '@/utility';
import types from '@/store/mutationTypes';

const setListener = (socket) => {
  socket.on('message', (message) => {
    const data = JSON.parse(message);
    const round = merge({}, data.round, {
      event: merge({}, data.event),
    });
    // eslint-disable-next-line
    const nextRounds = data.nextRounds;

    if (data.type === 'draw' && store.getters.ticket.bets.length) {
      store.commit(types.UPDATE_TICKET_BETS, store.getters.ticket);
      bus.$emit('updateBets');
    }
    store.commit(types.SET_ROUND, round);
    store.commit(types.SET_NEXT_ROUNDS, nextRounds);
  });
};

export default {
  init(config) {
    const socketUrl = `${process.env.VUE_APP_SOCKET_URL}:${store.getters.config.socket.port}`;
    const socket = io(socketUrl, {
      query: `wheelId=${config.wheel.id}&userId=${store.getters.user.id}`,
    });
    setListener(socket);
  },
};
